import { render, staticRenderFns } from "./balance-operation.vue?vue&type=template&id=43ffb68d"
import script from "./balance-operation.vue?vue&type=script&lang=js"
export * from "./balance-operation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/balance-operation/balance-operation.vue
// module id = l4xr
// module chunks = 0